 /* eslint-disable */
 (() => {
    "use strict";

    const opt = {
      complement: window.document.title,
      separator: ""
    };

    const diffTitle = {};
    let els = [];

    const util = {
      /**
       * Shorthand
       * @type {Object}
       */
      shorthand: {
        ch: "charset",
        tg: "target",
        n: "name",
        he: "http-equiv",
        ip: "itemprop",
        c: "content",
        p: "property",
        sc: "scheme",
        r: "rel",
        h: "href",
        sz: "sizes",
        t: "type",
        s: "src",
        a: "async",
        d: "defer",
        i: "inner"
      },

      /**
       * This function return the element <head>
       * @type {Function}
       * @return {Object}
       */
      getPlace(place) {
        return window.document.getElementsByTagName(place)[0];
      },

      /**
       * Undo the window.document title for previous state
       * @type {Function}
       * @param  {Object} state
       */
      undoTitle(state) {
        if (!state.before) return;
        window.document.title = state.before;
      },

      /**
       * Undo elements to its previous state
       * @type {Function}
       */
      undo() {
        if (!els.length) return;
        els.map(el => {
          el.parentElement.removeChild(el);
        });
        els = [];
      },

      /**
       * Set attributes in element
       * @type {Function}
       * @param  {Object} obj
       * @param  {HTMLElement} el
       * @return {HTMLElement} with defined attributes
       */
      prepareElement(obj, el) {
        Object.keys(obj).map(prop => {
          let sh = this.shorthand[prop] || prop;
          if (sh.match(/(body|undo|replace)/g)) return;
          if (sh === "inner") {
            el.textContent = obj[prop];
            return;
          }
          el.setAttribute(sh, obj[prop]);
        });
        return el;
      },

      /**
       * Change window.document title
       * @type {Function}
       * @param  {Object} val
       */
      title(val) {
        if (!val) return;
        diffTitle.before = opt.complement;
        let title = `${val.inner} ${val.separator ||
          opt.separator} ${val.complement || opt.complement}`;
        window.document.title = title.trim();
      },

      /**
       * Set attributes in element
       * @type {Function}
       * @param  {Object} obj
       * @param  {HTMLElement} el
       * @return {HTMLElement} with defined attributes
       */
      updateElement(obj, el) {
        Object.keys(obj).map(prop => {
          let sh = this.shorthand[prop] || prop;
          if (sh.match(/(body|undo|replace)/g)) return;
          if (sh === "inner") {
            el.textContent = obj[prop];
            return;
          }
          el.setAttribute(sh, obj[prop]);
        });
        return el;
      },

      update(arr, tag, place) {
        if (!arr) return;
        arr.map(obj => {
          let parent = obj.body
            ? this.getPlace("body")
            : this.getPlace(place);
          let el = window.document.querySelector(obj.selector);
          // if element exists then update the element
          if (el) {
            this.updateElement(obj, el);
            return;
          }

          if (!el) {
            el = window.document.createElement(tag);
          }
          // Other elements
          this.prepareElement(obj, el);
      
          // Add elements in Node
          this.add(obj, el, parent);
        });
      },

      add(obj, el, parent) {
        parent.appendChild(el);
        // Fixed elements that do not suffer removal
        if (obj.undo !== undefined && !obj.undo) return;
        // Elements which are removed
        els.push(el);
      },

      /**
       * Handle of create elements
       * @type {Function}
       * @param  {Array} arr
       * @param  {String} tag   - style, link, meta, script, base
       * @param  {String} place - Default 'head'
       * @param  {Boolean} update
       */
      handle(arr, tag, place) {
        if (!arr) return;
        arr.map(obj => {
          let parent = obj.body
            ? this.getPlace("body")
            : this.getPlace(place);
          let el = window.document.querySelector(obj.selector);

          // Elements that will substitute data
          if (el) {
            this.prepareElement(obj, el);
            return;
          }
          
          if (!el) {
            el = window.document.createElement(tag);
          }
          // Other elements
          this.prepareElement(obj, el);
      
          // Add elements in Node
          this.add(obj, el, parent);
        });
      }
    };

    const Shield = function(options) {
      function init() {
        let head =
          typeof options === "function" ? options.bind(this)() : options;
        if (!head) return;
        Object.keys(head).map(key => {
          let prop = head[key];
          if (!prop) return;
          let obj =
            typeof prop === "function" ? head[key].bind(this)() : head[key];
          if (key === "title") {
            util[key](obj);
            return;
          }
          util.handle(obj, key, "head");
        });
      }

      function destroy(head) {
        if (!head) return;
        util.undoTitle(diffTitle);
        util.undo();
      }


      function update(options) {
        let head =
          typeof options === "function" ? options.bind(this)() : options;
        if (!head) return;
        Object.keys(head).map(key => {
          let prop = head[key];
          if (!prop) return;
          let obj =
            typeof prop === "function" ? head[key].bind(this)() : head[key];
          if (key === "title") {
            util[key](obj);
            return;
          }
          util.update(obj, key, "head");
        });
      }

      return {
        init,
        destroy,
        update
      };
    };

    window.Shield = Shield;
  })();